// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactUs_contact__xseWt","title":"ContactUs_title__3amq6","text":"ContactUs_text__1QG2B"};